module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "returnGoodsInfo"
    }
  }, [_c('el-row', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-col', {
    staticClass: "fl",
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.backGo()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    attrs: {
      "span": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fl searthPart",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('p', {
    staticClass: "headerT"
  }, [_vm._v("采购退货信息")]), _vm._v(" "), _c('el-form', {
    ref: "returnForm",
    attrs: {
      "model": _vm.returnForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "采购退货单号:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "85%"
    },
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.code),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "code", $$v)
      },
      expression: "returnForm.code"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.returnForm.code, $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "采购订单编号:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "85%"
    },
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.pCode),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "pCode", $$v)
      },
      expression: "returnForm.pCode"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.returnForm.pCode, $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出入库编号:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "85%"
    },
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.storageCode),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "storageCode", $$v)
      },
      expression: "returnForm.storageCode"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont hohofast-copy copyBtn",
    on: {
      "click": function($event) {
        return _vm.handleCopy(_vm.returnForm.storageCode, $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.supplierName),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "supplierName", $$v)
      },
      expression: "returnForm.supplierName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退货时间:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.createTime),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "createTime", $$v)
      },
      expression: "returnForm.createTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退货原因:"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.reason),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "reason", $$v)
      },
      expression: "returnForm.reason"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    staticStyle: {
      "width": "78%"
    }
  }, [_c('el-card', {
    staticClass: "box-card fr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    },
    on: {
      "row-click": function($event) {
        return _vm.goToDetail()
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCoding",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "number",
      "label": "退货数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "price",
      "label": "采购单价(元）"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "amout",
      "label": "合计金额"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-c44ab62c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/purchaseManage/returnGoodsInfo.vue
// module id = 1747
// module chunks = 0